import { Stack } from '@mantine/core';

import type { SelectablePropertyItem } from '@repo/common/components/SingleSelector/types';
import { StaticProperty } from '../../EntityPropertySidebar';

export interface SecodaMetadataStackProps {
	createdAtLabelSecoda: string;
	updatedAtLabelSecoda: string;
	resourceTypeSecoda: string | null;
	withFrequentUsers: boolean;
	frequentUsersSecoda: SelectablePropertyItem[];
	viewsValue: string;
	entityId: string;
	source?: string;
}

function SecodaMetadataStack({
	createdAtLabelSecoda,
	updatedAtLabelSecoda,
	resourceTypeSecoda,
	withFrequentUsers,
	frequentUsersSecoda,
	viewsValue,
	entityId,
	source,
}: SecodaMetadataStackProps) {
	return (
		<Stack spacing="xs">
			{createdAtLabelSecoda && (
				<StaticProperty
					type="text"
					label="Created"
					value={createdAtLabelSecoda}
				/>
			)}
			{updatedAtLabelSecoda && (
				<StaticProperty
					type="text"
					label="Updated"
					value={updatedAtLabelSecoda}
				/>
			)}
			{resourceTypeSecoda && (
				<StaticProperty type="text" label="Type" value={resourceTypeSecoda} />
			)}
			{source && <StaticProperty type="source" label="Source" value={source} />}
			{withFrequentUsers && frequentUsersSecoda.length > 0 && (
				<StaticProperty
					type="users"
					label="Frequent users"
					value={frequentUsersSecoda}
				/>
			)}
			<StaticProperty type="text" label="Views" value={viewsValue} />
		</Stack>
	);
}

export default SecodaMetadataStack;
